<script lang="ts" setup>
import ArrowRight from 'assets/icons/arrows/arrowRight.svg'
import ArrowOut from 'assets/icons/arrows/16/arrow-up-rigth.svg'
import useAccountStore from '~/shared/store/modules/account'
import { useConfigStore } from '~/shared/store/modules/config'
import type { IServerConfig } from '~/shared/interfaces/config'
import config from '~/shared/config'
const accountStore = useAccountStore()
const configStore = useConfigStore()
const environmentConfig = configStore.config as IServerConfig | null

const getNavLinks = computed(() =>
  accountStore.accountNavigationList.filter(({ value }) => value !== 'account')
)
</script>

<template>
  <div class="navigation-popup__top">
    <NuxtLink to="/account" class="orange-link-hover">
      <span>Мой профиль</span>
      <span>
        <ArrowRight />
      </span>
    </NuxtLink>
    <NuxtLink
      class="orange-link-hover"
      v-if="accountStore.userRole === 'admin'"
      target="_blank"
      :to="environmentConfig?.manageUrl ?? config().manageUrl"
    >
      <span>Админ-панель</span>
      <span>
        <ArrowOut />
      </span>
    </NuxtLink>
  </div>
  <div class="navigation-popup__middle">
    <NuxtLink
      class="orange-link-hover"
      v-for="link in getNavLinks"
      v-show="Object.keys(link).includes('show') ? link.show : true"
      :key="`popup_link_${link.path}`"
      :to="link.path"
    >
      {{ link.name }}
      <span class="navigation-popup__counter" v-if="link.counter">
        {{ link.counter }}
      </span>
    </NuxtLink>
  </div>
  <div class="navigation-popup__bottom">
    <slot name="logout" />
  </div>
</template>

<style lang="scss" scoped>
@use 'assets/styles/components/navigation/navigation-popup.scss';
</style>
